import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormProvince, { ProvinceForm } from 'system/geographic/components/province/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonProvinceCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Province } from 'shell/models/province';

const ProvinceDetailPage = (): React.ReactElement => {
  const params = useParams();

  const {
    get: getProvince,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Province>>(
    `${__MUNICIPALITY_API_URL__}/geo/provincia/${params.id}`
  );

  useEffect(() => {
    getProvince();
  }, []);

  const province: ProvinceForm = useMemo(() => {
    const provincePayload = data?.payload;
    if (!provincePayload || !!error) {
      return {};
    }
    return {
      code: provincePayload.key.codice,
      name: provincePayload.nome,
      region: provincePayload.codRegione,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonProvinceCrumbs, { name: 'Dettaglio Provincia' }]} />
      {loading || error || !data ? undefined : (
        <FormProvince
          title="Dettaglio Provincia"
          onOk={onSubmit}
          initialValues={province}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/italia/provincia');
          }}
        />
      )}
    </Fragment>
  );
};

ProvinceDetailPage.displayName = 'Province Detail page component';

export default ProvinceDetailPage;
